import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  documentVersion: 0,
  selectedRow: null,
  formData: {
    __ROWSTATE: 'NEW',
    originalDetail: [],
    saldo_id: '',
    saldo_descr: '',
    periode_id: '',
    saldo_createdby: '',
    saldo_createddate: '',
    saldo_modifyby: '',
    saldo_modifydate: '',
    rowid: '',
    detail: [],
    log: [],
  },
  dataList: [],
  totalData: 0,
  loading: false,
  error: null,
  loadingMessage: '',
  activeTab: 0,
};

const inv07saldoSlice = createSlice({
  name: 'inv07saldo',
  initialState,
  reducers: {
    startNewData: (state) => {
      state.documentVersion += 1;
      state.formData = initialState.formData;
      state.selectedRow = null;
      state.loading = false;
      state.loadingMessage = '';
      state.error = null;
      state.activeTab = 1;
    },
    setSelectedRow: (state, action) => { state.selectedRow = action.payload; },
    setFormData: (state, action) => { state.formData = action.payload; },
    clearFormData: (state) => { state.formData = initialState.formData; },
    setLoading: (state, action) => { state.loading = action.payload; },
    setErrorMsg: (state, action) => { state.error = action.payload; },
    setLoadingMessage: (state, action) => { state.loadingMessage = action.payload; },
    setDataList: (state, action) => { state.dataList = action.payload; },
    setTotalData: (state, action) => { state.totalData = action.payload; },
    fetchDetailSuccess: (state, action) => {
      state.formData = {
        ...initialState.formData,
        ...action.payload,
        __ROWSTATE: 'UPDATE',
        originalDetail: action.payload?.detail || [],
        detail: action.payload?.detail || [],
        log: action.payload?.log || [],
      };
      state.loading = false;
      state.error = null;
    },
    fetchDetailFailure: (state, action) => { state.loading = false; state.error = action.payload; },
    fetchDetailError: (state, action) => { state.loading = false; state.error = action.payload; },
    updateFormData: (state, action) => {
      state.loading = false;
      state.formData = { ...state.formData, ...action.payload };
    },
    setDetailData: (state, action) => {
      state.formData.detail = action.payload;
    },
    resetState: () => initialState,
    setActiveTab: (state, action) => { state.activeTab = action.payload; },
    clearModuleState: (state) => {
      state.activeTab = 0;
      state.dataList = [];
      state.totalData = 0;
      state.loading = false;
      state.loadingMessage = '';
      state.error = null;
      state.selectedRow = null;
      state.formData = initialState.formData;
    },
  },
});

export const {
  startNewData,
  setSelectedRow,
  setFormData,
  clearFormData,
  setLoading,
  setErrorMsg,
  setLoadingMessage,
  setDataList,
  setTotalData,
  fetchDetailSuccess,
  fetchDetailFailure,
  fetchDetailError,
  updateFormData,
  setDetailData,
  resetState,
  setActiveTab,
  clearModuleState,
} = inv07saldoSlice.actions;

export default inv07saldoSlice.reducer;
